<div class="custom-sheet" [class.open]="exibirModal">
  <div class="sheet-header">
    <h2 class="sheet-title">
      {{ "COMPONENTS.SELECIONAR_IDIOMA.title" | transloco }}
    </h2>

    <p class="sheet-description">
      {{ "COMPONENTS.SELECIONAR_IDIOMA.description" | transloco }}
    </p>
  </div>

  <div class="language-list">
    <button
      *ngFor="let language of languages; let i = index"
      (click)="selecionarIdioma(language)"
      class="language-item"
      [class.selected]="linguagemSelecionada.code === language.code"
      [style.animation-delay]="i * 50 + 'ms'"
    >
      <div class="language-info">
        <span class="language-flag">{{ language.flag }}</span>

        <div class="language-text">
          <p class="language-name">{{ language.name }}</p>

          <p class="language-code">{{ language.code }}</p>
        </div>
      </div>

      <div *ngIf="linguagemSelecionada.code === language.code" class="check">
        ✔
      </div>
    </button>
  </div>

  <div class="current-language">
    {{ "COMPONENTS.SELECIONAR_IDIOMA.currentLanguage" | transloco }}:

    <span>
      {{ linguagemSelecionada.name }}
    </span>
  </div>
</div>
